declare function require(name: string)

/* eslint-disable @typescript-eslint/no-var-requires, no-var */
const degradedStatusMarker = require('./map-markers/Amber@2x.png')
const optimalStatusMarker = require('./map-markers/Green@2x.png')
const issuesStatusMarker = require('./map-markers/Red@2x.png')
const noDataStatusMarker = require('./map-markers/Grey@2x.png')
const leavingImage = require('./Leaving.svg')
const filterIcon = require('./icons/filter_icon.svg')
const validationSuccess = require('./validation_success.svg')
const errorMessageIcon = require('./Error_Message_Icon.png')

export {
  degradedStatusMarker,
  optimalStatusMarker,
  issuesStatusMarker,
  noDataStatusMarker,
  leavingImage,
  filterIcon,
  validationSuccess,
  errorMessageIcon,
}
